import { ArticleDefinition, RequiredArticle } from './Article';

export enum ViolationType {
  LIMIT = 'LIMIT',
  STABILITY = 'STABILITY',
  LIGHTING = 'LIGHTING',
  DISCONTINUED_ARTICLES = 'DISCONTINUED_ARTICLES',
  CAPACITY = 'CAPACITY',
  UNKNOWN = 'UNKNOWN',
}

export enum ValidationActionType {
  ADD = 'ADD',
  REMOVE = 'REMOVE',
  REPLACE = 'REPLACE',
}

export interface ValidationArticle {
  article: ArticleDefinition;
  productNumber: string;
  amount: number;
  isDefault: boolean;
}

export interface ValidationAction {
  type: ValidationActionType;
}

export interface AddValidationAction extends ValidationAction {
  articles: ValidationArticle[];
}

export interface RemoveValidationAction extends ValidationAction {
  articles: ArticleDefinition[];
}

export interface ValidationError {
  type: ViolationType;
  fixable: boolean;
  message?: string;
  action?: ValidationAction;
  articleNumber?: string;
}

export interface ValidationResult {
  fixableErrors: ValidationError[];
  unfixableErrors: ValidationError[];
}

export interface ValidLightingSetup {
  articleId: string;
  requiredLightingArticles: RequiredArticle[];
}

export const LIGHTNING_SETUP_CORRECT_NO_CHANGE_NEEDED = 'LIGHTNING_SETUP_CORRECT_NO_CHANGE_NEEDED';
export type LIGHTNING_SETUP_CORRECT_NO_CHANGE_NEEDED_TYPE = 'LIGHTNING_SETUP_CORRECT_NO_CHANGE_NEEDED';

export interface ValidationAndLightingSetup {
  validation: ValidationResult;
  lightingSetup: ValidLightingSetup[] | LIGHTNING_SETUP_CORRECT_NO_CHANGE_NEEDED_TYPE;
}
